import {
  LOG_OUT,
  OTP_LOADING,
  VERFIY_FAILD,
  VERFIY_SUCCESS,
  RESET_OTP,
} from "../types";

const initialState = {
  loading: false,
  error: null,
  data: null,
  otpMessage: null,
};

export const otpReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; error: any }
) => {
  switch (action.type) {
    case OTP_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
        data: null,
        otpMessage: null,
      };

    case VERFIY_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        otpMessage: action.payload.message,
      };
    case VERFIY_FAILD:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case LOG_OUT:
      return {
        ...state,
        loading: false,
        error: null,
        otpMessage: null,
      };

    case RESET_OTP:
      return initialState;
    default:
      return state;
  }
};
